import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { ExamDayFilter } from '../../../src/db/filter/examday-filter.js';
import { ILSStatistics } from '../db/statistics.js';
import { getExamDayStatisticsResolver } from '../server/resolver.js';

export const getExamDayStatistics = registerQuery({
  operationName: 'getExamDayStatistics',
  resolve: getExamDayStatisticsResolver,
  type: type => ILSStatistics,
  params: [{ type: () => ExamDayFilter, name: 'filter' }],
});
